module.exports = __webpack_public_path__ + "static/img/r_012.7b632fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_012.jpg
// module id = ox/H
// module chunks = 1